import React, { useState } from "react"
import Popover from "@material-ui/core/Popover"
import { makeStyles } from "@material-ui/core/styles"
import { connect } from "react-redux"
import { setSort } from "../actions/settingsActions"
import { FormattedMessage } from "react-intl"
import ChevDown from "../assets/icons/chevDown"
import ChevRight from "../assets/icons/chevRight"

const useStyles = makeStyles({
  paper: {
    borderRadius: "16px",
    boxShadow: "0px 10px 15px rgba(79, 103, 136, 0.15)",
    padding: "1rem",
  },
})

const SortComponent = ({ lang, ...props }) => {
  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null)

  const classes = useStyles()

  const closePopover = () => {
    setPopoverAnchorEl(null)
  }

  const handleSort = sort => {
    props.setSort(sort)
    closePopover()
  }

  return (
    <>
      <div>
        <button
          className="primary whiteBg shadow-lg br8 px20 px-3 sortSelect"
          onClick={e => setPopoverAnchorEl(e.currentTarget)}
        >
          <FormattedMessage defaultMessage="Sort" />
          <ChevRight />
        </button>
      </div>
      <Popover
        open={!!popoverAnchorEl}
        anchorEl={popoverAnchorEl}
        onClose={closePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        classes={{ paper: classes.paper }}
      >
        <div className="d-flex flex-column">
          <button
            className="px20 black my-2 primaryHover"
            onClick={() => handleSort("")}
          >
            <FormattedMessage defaultMessage="Default" />
          </button>
          <button
            className="px20 black my-2 primaryHover"
            onClick={() => handleSort("price,ASC")}
          >
            <FormattedMessage defaultMessage="Price: low to high" />
          </button>
          <button
            className="px20 black my-2 primaryHover"
            onClick={() => handleSort("price,DESC")}
          >
            <FormattedMessage defaultMessage="Price: high to low" />
          </button>

          <button
            className="px20 black my-2 primaryHover"
            onClick={() => handleSort("createdAt,DESC")}
          >
            <FormattedMessage defaultMessage="Newest to oldest" />
          </button>
          <button
            className="px20 black my-2 primaryHover"
            onClick={() => handleSort("createdAt,ASC")}
          >
            <FormattedMessage defaultMessage="Oldest to newest" />
          </button>
        </div>
      </Popover>
    </>
  )
}

const mapStateToProps = ({ settings: { lang } }) => ({ lang })
export default connect(mapStateToProps, { setSort })(SortComponent)
